module.exports = __webpack_public_path__ + "img/Auto Constante.f1f9fe0a.svg";